export default (el) => {
  let lastScroll = 0;
  let isScrolled = false;

  window.addEventListener("scroll", function () {
    let topHeader = document.querySelector('header');
    let currentScroll =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    let scrollDirection = currentScroll < lastScroll;
    let shouldToggle = isScrolled && scrollDirection;
    isScrolled = currentScroll > 100;
    topHeader.classList.toggle("active", shouldToggle);
    lastScroll = currentScroll;
  });

}
